import React from "react";
import CatalogoPageLayout from "./CatalogoPageLayout";

const CatalogoCombosPage: React.FC = () => (
  <CatalogoPageLayout
    title="Combos"
    description="Armá combos flexibles con artículos fijos, opcionales y precios promocionales."
    helperText="Desde esta vista se podrán definir reglas de cambio de ingredientes y su impacto en el costo."
  />
);

export default CatalogoCombosPage;
